import { Toaster as SonnerToaster } from "sonner";

// Custom Toast component
export const Toaster = () => {
  return (
    <SonnerToaster
      position="top-right"
      duration={0}
      offset={{ top: 60, right: -20 }}
      toastOptions={{
        style: {
          background: "#7872C8",
          color: "white",
          border: "none",
          padding: "6px 12px 6px 12px",
          // paddingRight: "40px", // Add extra padding for close button
          borderRadius: "6px",
          boxShadow: "0px 2px 10px 0px #0000004D",
          fontSize: "14px",
          width: "292px",
          position: "relative", // For absolute positioning of close button
        },
        className: "my-custom-toast",
      }}
      closeButton
    />
  );
};
